import { createFileRoute } from '@tanstack/react-router'

import { ClientImportPage } from '@/pages/clients/import/ClientImportPage'

export const Route = createFileRoute('/_authenticated/_dashboard/clients/import/')({
  component: ClientImportPage,
})
